import { useState } from 'react';

import { EXTERNAL_TOOLS, ExternalTool } from '../../../config/external-tools';
import { openExternalTool } from '../../../utils/external-tool.service';
import { Panel, PanelHeader, PanelTitle, PanelSubtitle } from '../styles';
import { ToolRow } from './ToolRow';
import { HoverInfo } from './ModuleRow';

interface ExternalToolsPanelProps {
  height: number;
  onHover?: (info: HoverInfo | null) => void;
}

export const ExternalToolsPanel = ({ height, onHover }: ExternalToolsPanelProps) => {
  const [openedTool, setOpenedTool] = useState<string | null>(null);

  const handleOpen = (tool: ExternalTool) => {
    if (tool.vpn) {
      openExternalTool(tool);
      return;
    }
    setOpenedTool(tool.id);
    openExternalTool(tool);
    setTimeout(() => setOpenedTool(null), 2000);
  };

  return (
    <Panel style={{ height }}>
      <PanelHeader>
        <PanelTitle>Herramientas externas</PanelTitle>
        <PanelSubtitle>Acceso con SSO automático</PanelSubtitle>
      </PanelHeader>

      {EXTERNAL_TOOLS.map((tool) => (
        <ToolRow
          key={tool.id}
          tool={tool}
          isOpening={openedTool === tool.id}
          onOpen={handleOpen}
          onHover={onHover}
        />
      ))}
    </Panel>
  );
};
